angular.module('leanlaw').directive('llChargeStage', [function () {
  return {
    restrict: 'A',
    //                require: '^ngModel',
    scope: {
      stage: '=ngModel',
      index: '=',
      onDelete: '&',
      onEdit: '&',
      onSave: '&'
    },
    template: require('./views/chargeStage.html'),
    controller: ['$scope', function ($scope) {}]
  };
}]);